import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function ArticleHighlights() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <p className="text-xs text-foreground-500 font-label tracking-wider uppercase mb-2">Guida SEO 2026</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Le Nostre Guide
          </h2>
          <h3 className="text-2xl md:text-4xl font-heading italic font-light text-foreground-400 mt-1">
            In Evidenza
          </h3>
          <p className="text-sm text-foreground-500 mt-4">13 guide SEO originali per scoprire tutto su Itaobuy Spreadsheet</p>
        </div>

        {/* Article Cards Grid - 13 articles */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {seoArticles.map((article, idx) => {
            const bgColors = [
              'bg-accent-100/70',
              'bg-secondary-100/70',
              'bg-background-100',
              'bg-accent-50/80',
              'bg-secondary-50/70',
              'bg-background-100',
              'bg-accent-100/60',
              'bg-secondary-100/80',
              'bg-background-100',
              'bg-accent-50/60',
              'bg-secondary-100/70',
              'bg-background-100',
              'bg-accent-100/70',
            ];
            return (
              <Link
                key={article.slug}
                to={`/${article.slug}`}
                className="group cursor-pointer rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                <div className={`${bgColors[idx % 13]} p-3`}>
                  <div className="w-full h-48 rounded-xl overflow-hidden bg-background-200">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      title={`Itaobuy Spreadsheet — ${article.title}`}
                    />
                  </div>
                </div>
                <div className="bg-background-50 p-4 border border-background-100 border-t-0 rounded-b-2xl">
                  <span className="text-xs font-label text-accent-500 font-medium">{article.category}</span>
                  <h4 className="font-heading font-semibold text-base text-foreground-900 mt-2 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                    {article.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-100">
                    <span className="text-xs text-foreground-400 font-label">{article.readTime} di lettura</span>
                    <span className="text-xs text-accent-500 font-label font-medium flex items-center gap-1">
                      Leggi <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Bottom CTA to see all */}
        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-label font-semibold cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-colors"
          >
            Esplora il Database Completo <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}